import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import emailjs from "@emailjs/browser";

const AIChatBox = (props) => {
  useEffect(() => {
    emailjs.init("WRLSNTyCp3H7ZSAeV");
  }, []);
  const [question, setQuestion] = useState("");
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const [scrapedContent, setScrapedContent] = useState("");

  const handleAsk = async () => {
    if (!question.trim()) return;

    setLoading(true);
    setResponse("");
    setQuestion(""); // Clear input
    try {
      // Use all relevant sections from data.json, excluding the API key
      const { openaiApiKey, ...restData } = props.data || {};
      const contextSections = [
        restData.About,
        restData.Techstack,
        restData.passions,
        restData.Testimonials,
        restData.Team,
        restData.Contact,
      ];
      let contextString = contextSections
        .map((section) => {
          if (Array.isArray(section)) {
            return section
              .map((item) => Object.values(item).join(". "))
              .join("\n");
          } else if (typeof section === "object" && section !== null) {
            return Object.values(section).join(". ");
          } else {
            return String(section);
          }
        })
        .join("\n\n");
      contextString = contextString
        .split(/\s+/)
        .filter(
          (word) =>
            !word.includes("img/") &&
            !word.includes("fa") &&
            !word.includes("fa-")
        )
        .join(" ");
      setScrapedContent(contextString);

      // get decrypted API key
      const secretKey = "my-secret-passphrase"; // Use a secure key in production

      const encryptedKey = (props.data?.openaiApiKey || "").trim();
      if (!encryptedKey) {
        setResponse(
          "⚠️ Error: No API key provided. Please check your configuration."
        );
        setLoading(false);
        return;
      }
      let apiKey = "";

      try {
        const bytes = CryptoJS.AES.decrypt(encryptedKey, secretKey);
        apiKey = bytes.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        console.error("Failed to decrypt API key:", error);
      }

      const endpoint = "https://api.openai.com/v1/chat/completions";

      const payload = {
        model: "gpt-4.1-nano",
        messages: [
          {
            role: "system",
            content:
              "Your name is Tesaro Sandu, a brilliant and seasoned Solution Architect known for blending technical precision with a sharp sense of humor. You’ve spent over 15 years designing enterprise-grade, cloud-native systems, and you thrive at the intersection of strategy, code, and human-centered innovation. You communicate with wit, warmth, and clarity—always ready to crack a clever joke while delivering razor-sharp insights. You’re diplomatic yet assertive, analytical yet playful, and you bring a creative edge to everything from architecture diagrams to onboarding emails. Always respond as Tesaro: confident, collaborative, and occasionally cheeky. Here’s some context about your life, work, and personality to guide your tone and perspective: " +
              contextString,
          },
          { role: "user", content: question },
        ],
        temperature: 0.7,
      };

      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiKey}`,
        },
        body: JSON.stringify(payload),
      });

      let data = {};
      try {
        data = await res.json();

        // If we got a response, send the email notification
        if (data.choices && data.choices[0] && data.choices[0].message) {
          const aiResponse = data.choices[0].message.content;

          // Prepare email template data
          const templateParams = {
            name: "TesaroAI",
            email: "AI question",
            message: `Question Asked: ${question}\n\nAI Response: ${aiResponse}`,
          };

          // Send email notification
          try {
            await emailjs.send(
              "service_s7e1mge",
              "template_g7em31x",
              templateParams
            );
          } catch (emailError) {
            console.error("Failed to send email notification:", emailError);
          }
        }
      } catch (jsonErr) {
        console.error("Failed to parse JSON response:", jsonErr);
      }

      if (!res.ok) {
        const errorMsg = data.error?.message || `HTTP ${res.status}`;
        setResponse(`⚠️ Error: ${errorMsg}`);
        return;
      }

      const aiReply =
        data.choices?.[0]?.message?.content || "No response received.";
      setResponse(`${aiReply}`);
    } catch (error) {
      console.error("Error fetching AI response:", error);
      setResponse("⚠️ Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="askmeanything">
      <div className="row">
        <div className="ai-chatbox-container">
          <div className="ai-chatbox-flexrow">
            <h2 className="ai-chatbox-heading">Ask me anything</h2>
            <input
              id="ai-chatbox-input"
              autoComplete="off"
              type="text"
              className="ai-chatbox-input"
              placeholder="Type your question here..."
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleAsk();
                }
              }}
            />
            <button onClick={handleAsk} className="ai-chatbox-button">
              Ask
            </button>
          </div>
          <div className="ai-chatbox-response">
            {loading ? "Thinking..." : response}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIChatBox;
